export const DEFAULT_ERROR_MESSAGE = 'Failed get buy analytics payment url';
